import Yup from 'utils/validation/yup-extensions';

export const CSS_CLASSES = {
	SECTION_HEADER: 'section-header',
};

/**
 * Address types
 */
export const ADDRESS_FORM_TYPE = {
	OFFICE: 'office',
	INTERNATIONAL: 'international',
	US: 'us',
};

/**
 * Default country value.
 * @type {string}
 */
export const COUNTRY_DEFAULT = 'US';

/**
 * Form property keys.
 */
export const FORM_KEYS = {
	ADDRESS_HOME_STREET_1: 'ADDRESS_HOME_STREET_1',
	ADDRESS_HOME_STREET_2: 'ADDRESS_HOME_STREET_2',
	ADDRESS_HOME_COUNTRY: 'ADDRESS_HOME_COUNTRY',
	ADDRESS_HOME_ZIP_POSTAL: 'ADDRESS_HOME_ZIP_POSTAL',
	ADDRESS_HOME_STATE_PROVINCE: 'ADDRESS_HOME_STATE_PROVINCE',
	ADDRESS_HOME_CITY: 'ADDRESS_HOME_CITY',
};

/**
 * Default Formik form initial value object.
 * @type {object}
 */
export const FORM_INITIAL_VALUES = Object.keys(FORM_KEYS).reduce((acc, key) => {
	acc[FORM_KEYS[key]] =
		key === FORM_KEYS.ADDRESS_HOME_COUNTRY ? COUNTRY_DEFAULT : '';
	return acc;
}, {});

export const VALIDATION_MESSAGES = {
	DEFAULT: 'Invalid input.',
	REQUIRED: 'This field is required',
	MAX: 'The maximum number of characters has been exceeded',
};

/**
 * Default Formik form Yup validation schema logic.
 * @type {object}
 */
export const FORM_VALIDATION_SCHEMA_OBJECT = {
	[FORM_KEYS.ADDRESS_HOME_STREET_1]: Yup.string()
		.required(VALIDATION_MESSAGES.REQUIRED)
		.maxCounter(32),
	[FORM_KEYS.ADDRESS_HOME_STREET_2]: Yup.string().maxCounter(32),
	[FORM_KEYS.ADDRESS_HOME_COUNTRY]: Yup.string().required(
		VALIDATION_MESSAGES.REQUIRED
	),
	//TODO - addmethod
	[FORM_KEYS.ADDRESS_HOME_ZIP_POSTAL]: Yup.string().maxCounter(32),
	[FORM_KEYS.ADDRESS_HOME_STATE_PROVINCE]: Yup.string().required(
		VALIDATION_MESSAGES.REQUIRED
	),
	[FORM_KEYS.ADDRESS_HOME_CITY]: Yup.string().required(
		VALIDATION_MESSAGES.REQUIRED
	),
};

/**
 * Default Formik form Yup validation schema object.
 * @type {object}
 */
export const FORM_VALIDATION_SCHEMA = Yup.object(FORM_VALIDATION_SCHEMA_OBJECT);
